// src/data/coverage/openingCoverageState.ts
// ============================================================
// THE OPENING COVERAGE STATE — what Act 1 starts from
//
// Not in the original file list for this layer, and here on purpose: the reducer test and
// the panel in the next prompt both need a definition of "opening state", and two copies of
// it is exactly the duplication the hard rule in computeCoverage exists to prevent.
//
// It holds NO numbers. Every list below is a reference to a binding table, so the opening
// coverage counts are a consequence of those tables rather than something typed here. If a
// binding changes, this state changes with it and the reducer test reports the new totals.
//
// WHAT IT ASSERTS ABOUT THE DEMO:
//   · all three survey modules are complete   (matches Surveys 100 in the seed vector)
//   · the three profile fields carry values   (matches Profile 100, ACME_ORG_PROFILE)
//   · NO documents are present                (matches Docs 0 of 4 in the seed vector)
//
// ─────────────────────────────────────────────────────────────────────────────
// ZERO DOCUMENTS IS THE POINT. An earlier version of this file seeded the three canonical
// strategy PDFs as evidence. It had to go, for the reason the prompt-1 work surfaced:
// all three bind to the SAME seven Strategic Value measures, so the counts came out
// byte-identical whether one document was loaded or three. The on-camera Path A upload
// therefore moved nothing on the panel.
//
// Opening at zero makes that upload the first evidence the client has, which is both the
// honest reading of an account that has uploaded nothing and the beat the demo needs.
// It also puts this file in agreement with the Docs tracker, which now seeds at 0 of 4.
// ─────────────────────────────────────────────────────────────────────────────
// ============================================================

import { PROFILE_FIELD_BINDINGS } from './profileMeasureBindings';
import { SURVEY_MODULE_BINDINGS, type SurveyModuleId } from './surveyMeasureBindings';
import type { ProfileFieldKey } from './profileMeasureBindings';

export interface OpeningCoverageState {
  completedSurveyModules: SurveyModuleId[];
  populatedProfileFields: ProfileFieldKey[];
  /** Always empty at open. See the header. */
  evidenceSources: never[];
}

export const OPENING_COVERAGE_STATE: OpeningCoverageState = {
  completedSurveyModules: SURVEY_MODULE_BINDINGS.map((b) => b.id),
  populatedProfileFields: PROFILE_FIELD_BINDINGS.map((b) => b.key),
  evidenceSources: [],
};
